export enum CfgIntegracaoHttpMethod {

  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE'

}